/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'breakpoints',
    'javascript-debounce',
    'velocity',
    'pip-events'
],
function (
    $,
    breakpoints,
    debounce,
    velocity,
    pipEvents
){
    var cardOverlayInstance;
    var cardOverlayTemplate = '<div class="card__overlay pip-now no-gutters">' +
                                    '<div class="card__overlay-wrapper">' +
                                        '<div class="card__overlay-go-back">' +
                                            '<span>Back</span>' +
                                        '</div>' +
                                        '<div class="card__overlay-body"></div>' +
                                    '</div>' +
                                '</div>';

    var view = {
        selectors: {
            richContentLinkOverlayTrigger: '.feature-rich-content-mobile-enabled .tnt-rich-content--link .card__footer[data-anchor-point=".rich-content-container"]',
            richContentTabsOverlayTrigger: '.feature-rich-content-mobile-enabled .tnt-rich-content--tabs [data-anchor-point], .feature-rich-content-mobile-enabled .card__tabs-header',
            richContentTabsActiveToggleTarget: '.card__tabs-header span, .card__tabs-content'
        }
    };

    var CardOverlay = function () {
        if ($('.feature-rich-content-mobile-enabled').length) {
            cardOverlayTemplate = '<div class="feature-rich-content-mobile-enabled">' + cardOverlayTemplate + '</div>';
        }

        $('body').append(cardOverlayTemplate);

        this.overlay = $('.card__overlay');
        this.overlayBody = $('.card__overlay .card__overlay-body');
    };

    CardOverlay.prototype.show = function show(markup) {
        this.overlayBody.html(markup);
        this.overlay.addClass('out');
        $('body').addClass('noscroll');

        pipEvents.cards.cardOverlayDisplayed.trigger();
    }

    CardOverlay.prototype.hide = function hide() {
        var _this = this;
        _this.overlay.removeClass('out');
        setTimeout(function () {
            _this.overlayBody.empty();
        }, 500);
        $('body').removeClass('noscroll');
        pipEvents.cards.cardOverlayHidden.trigger();
    }

    function onCardClick(target) {
      var cardTitle = target.closest('.card').find('.row-header__text')
        .first().text().trim().toLowerCase();
      var cardCheck = cardTitle === 'specifications' || cardTitle === 'product overview';
      if (cardCheck) {
        pipEvents.cards.cardClicked.trigger(cardTitle);
      }
    }

    function initEventListeners() {
        $(document).off('.card');
        $(document).on('touchend.card click.card', '.card__body', function(e) {
          onCardClick($(this));
            if (breakpoints.isActiveBreakpointEqualToOrSmallerThan('ExtraSmall')) {
                if($(this).hasClass('no-slide')) {
                    window.location = $(this).attr('data-url');
                    return;
                }
                var markup = $(this).children('.card__contents').html();
                cardOverlayInstance.show(markup);
            }
        });

        $(document).on('touchend.card click.card', '.card__overlay-go-back', function(e) {
            e.stopPropagation();
            cardOverlayInstance.hide();
            return false;
        });

        $(document).on('touchend.card click.card', '.card__footer.slide', function(e) {
            e.preventDefault();
            var markup = $(this).closest('.card').find('.card__contents').html();
            var anchorPoint = $(this).attr('data-anchor-point');
            cardOverlayInstance.show(markup);
            onCardClick($(this));

            $('#moreinfo_wrapper').velocity('scroll', {
                container: $('.card__overlay-wrapper'),
                duration: 1000,
                offset: 0,
                easing: 'ease-in-out',
                delay: 500
            });
        });

        $(document).on('touchend.card click.card', view.selectors.richContentLinkOverlayTrigger, function (e) {
            e.preventDefault();
            var anchorPoint = $(this).attr('data-anchor-point');
            var markup = $(anchorPoint).html();
            cardOverlayInstance.show(markup);
        });

        $(document).on('touchend.card click.card', view.selectors.richContentTabsOverlayTrigger, function (e) {
            e.preventDefault();

            $(view.selectors.richContentTabsActiveToggleTarget).removeClass('active');

            var anchorPoint = $(this).attr('data-anchor-point');
            var anchorPointAttributeSelector = '[data-anchor-point="' + anchorPoint + '"]';
            $('.card__tabs-header' + anchorPointAttributeSelector +  ' span').addClass('active');
            $('.card__tabs-content' + anchorPointAttributeSelector).addClass('active');

            var markup = $('.card__tabs')[0].outerHTML + $(anchorPoint).html();
            cardOverlayInstance.show(markup);
        });

        $(window).on('resize.card', function (e) {
            debounce(resetCardOnResize(), 250);
        });

        $('.card__overlay-wrapper').on('scroll.card', function (e) {
            var scrollingDiv = this;
            debounce(displayShadow(scrollingDiv), 250);
        });
    }


    function resetCardOnResize() {
        if(cardOverlayInstance && breakpoints.isActiveBreakpointEqualToOrLargerThan('Small')) {
            cardOverlayInstance.hide();
        }
    }

    function displayShadow(scrollingDiv) {
        var scrollPostion = $(scrollingDiv).scrollTop();
        $('.card__overlay-go-back').toggleClass('with-shadow', scrollPostion > 10);
    }

    return {
        init: function init() {
            $('.card__body').addClass('scrollTouch');
            if(!cardOverlayInstance) {
                cardOverlayInstance = new CardOverlay();
            }
            initEventListeners();
        }
    }
});

}.call(window));